import _axios from "../axios.config";
import { END_POINTS } from "./endPoints";
import { toast } from "react-toastify";
export const AddEventsApis = async (data) => {
  try {
    let response = await _axios.post(END_POINTS.ADD_EVENTS, data);
    console.log("response of api is=========>", response);
    return {
      success: true,
      data: response?.data,
    };
  } catch (e) {
    console.log("errrrrrrrrrrrrror", e);
    let errorMessage =
      e?.response?.data?.errors[0]?.message ||
      e?.response?.data?.message ||
      "Something went wrong";
    toast.error(errorMessage);
    return {
      success: false,
      error: e,
    };
  }
};

export const EditEventsApis = async (data, id) => {
  try {
    let response = await _axios.put(`${END_POINTS.EDIT_EVENTS}${id}`, data);
    console.log("response of api is=========>", response);
    return {
      success: true,
      data: response?.data,
    };
  } catch (e) {
    console.log("errrrrrrrrrrrrror", e);
    let errorMessage =
      e?.response?.data?.errors[0]?.message ||
      e?.response?.data?.message ||
      "Something went wrong";
    toast.error(errorMessage);
    return {
      success: false,
      error: e,
    };
  }
};

export const GetMyEvents = async () => {


  try {
    let response = await _axios.get(`${END_POINTS.GET_MY_EVENTS}`);
    console.log(this?.name, "response =========>", response);
    return {
      success: true,
      data: response?.data,
    };
  } catch (e) {
    console.log("errrrrrrrrrrrrror", e);
    let errorMessage =
      e?.response?.data?.errors[0]?.message ||
      e?.response?.data?.message ||
      "Something went wrong";
    toast.error(errorMessage);
    return {
      success: false,
      error: e,
    };
  }


}


export const getAllEventsApi = async (
  lat,
  lng,
  radius,
  options = {},
  isContributor = "",
) => {
  try {
    if (isContributor === "" || isContributor === false) {
      isContributor = "";
    }

    const baseParams = {
      lat,
      lng,
      radius,
      isContributor,
      ...options,
    };
    console.log("base-params", baseParams)
    const query = Object.entries(baseParams)
      .filter(
        ([_, value]) => value !== undefined && value !== null && value !== ""
      )
      .map(([key, value]) => {
        if (
          (key === "categories" || key === "discounts") &&
          typeof value === "string"
        ) {
          value = value.replace(/\s+/g, "");
        }
        return `${key}=${encodeURIComponent(value)}`;
      })
      .join("&");

    const finalUrl = `${END_POINTS.GET_ALL_EVENTS}?${query}`;

    // ✅ Human-readable logging
    console.log("getAllEventsApi URL (decoded):", decodeURIComponent(finalUrl));

    // 👇 Make the actual request with encoded URL
    const response = await _axios.get(finalUrl);


    return response;
  } catch (error) {
    console.error("getAllEventsApi error:", error?.message || error);


    return ({
      ...(error?.response?.data || { message: "Unexpected error" }),
      status: 400,
    });
  }
}
